import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Event from 'akasia-components/eventos/Event';

const LeadEvents = ({
    eventosActivos,
    detallesLead,
    GuardarComentario,
    TerminarEvento,
    procesandoModal,
    habilitarBtnTerminarEvento,
    editarEventos,
    showAgregarEvento,
    setShowAgregarEvento,
    setFormDataEvent,
    formDataEvent
}) => {
    return (
        <Col className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 border-end">
            <Row>
                <Col className="col-12 fs--1">
                    <h5>
                        <img width="30" src="/img/calendario48.png" alt="Calendario"></img>
                        &nbsp;Eventos
                    </h5>
                </Col>
            </Row>
            <Row>
                {eventosActivos && eventosActivos.length > 0 ? (
                    eventosActivos.map((event, index) => (
                        <Col key={index} className="h-100 mt-2 col-12">
                            <Event
                                details={event}
                                GuardarComentario={GuardarComentario}
                                TerminarEvento={TerminarEvento}
                                idLead={detallesLead.idLead}
                                procesandoModal={procesandoModal}
                                habilitarBtnTerminarEvento={habilitarBtnTerminarEvento}
                                editarEventos={editarEventos}
                            />
                        </Col>
                    ))
                ) : (
                    <Col md={12}>
                        {!showAgregarEvento && (
                            <button
                                onClick={() => {
                                    setFormDataEvent({
                                        ...formDataEvent,
                                        dFechaEvento: new Date(),
                                        vTituloEvento: '',
                                        vDescripcionEvento: ''
                                    });
                                    setShowAgregarEvento(true);
                                }}
                                className="d-sm-block me-2 btn btn-falcon-default btn-sm"
                            >
                                Crear evento
                            </button>
                        )}
                    </Col>
                )}
            </Row>
        </Col>
    );
};

LeadEvents.propTypes = {
    eventosActivos: PropTypes.array,
    detallesLead: PropTypes.object.isRequired,
    GuardarComentario: PropTypes.func.isRequired,
    TerminarEvento: PropTypes.func.isRequired,
    procesandoModal: PropTypes.bool,
    habilitarBtnTerminarEvento: PropTypes.bool,
    editarEventos: PropTypes.func.isRequired,
    showAgregarEvento: PropTypes.bool.isRequired,
    setShowAgregarEvento: PropTypes.func.isRequired,
    setFormDataEvent: PropTypes.func.isRequired,
    formDataEvent: PropTypes.object.isRequired
};

export default LeadEvents;
